module.exports = __webpack_public_path__ + "static/media/Maf_EstrategiaDeSeguridadYJusticia_Home.582d5e89.jpg";